import { Action } from 'redux-actions';

export interface IAnalyticsInstace {
	track: (name: string, attributes: IAnalyticsObject) => void;
}

export interface IAnalyticsObject {
	label: string;
	category: string;
	[x: string]: string;
}

export interface IAnalyticsActionsObject {
	[x: string]: <T extends Action<any>>(action: T) => Array<{ name: string; attributes: IAnalyticsObject }> | undefined;
}

export let AnalyticsActionsObject: IAnalyticsActionsObject = {};

export const registerAnalyticsActions = (analyticsActions: IAnalyticsActionsObject) => {
	AnalyticsActionsObject = {
		...AnalyticsActionsObject,
		...analyticsActions,
	};
};

export const analyticsTrack = (name: string, attributes: IAnalyticsObject) => {
	try {
		// console.log(name, attributes);
		window && window.analytics && window.analytics.track(name, attributes);
	} catch (e) {
		console.error('analytics is not defined!!!');
	}
};
